// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront15 from "pages/Servicii/ServiciiSpeciale/CuratenieBirouriSedii/sections/sections/images/bgFront15.webp";
import bgBack15 from "pages/Servicii/ServiciiSpeciale/CuratenieBirouriSedii/sections/sections/images/bgBack15.webp";

function InformationHome() {
    return (
        <MKBox component="section" py={6} my={6}>
            <Container>
                <Grid
                    container
                    item
                    spacing={4}
                    alignItems="center"
                    justifyContent="center"
                    sx={{ textAlign: "center" }}
                >
                    {/* ROTATING CARD */}
                    <Grid item xs={12} lg={4} sx={{ mx: "auto" }} spacing={2}>
                        <RotatingCard>
                            <RotatingCardFront
                                image={bgFront15}
                                icon="storefront"
                                title={
                                    <>
                                        Curățenie pentru
                                        <br />
                                        Birouri/Sedii
                                    </>
                                }
                                description="Experiență, tehnologie și personal instruit – curățenie impecabilă"
                            />
                            <RotatingCardBack
                                image={bgBack15}
                                title="Calitate vizibilă, eficiență constantă"
                                description="Contactează-ne pentru o ofertă personalizată și consultanță gratuită."
                                action={{
                                    type: "internal",
                                    route: "/contact-curatenie",
                                    label: "cere o ofertă",
                                }}
                            />
                        </RotatingCard>
                    </Grid>

                    {/* 6 INFO CARDS */}
                    <Grid item xs={12} lg={7} sx={{ textAlign: "center" }} ml={6}>
                        <Grid
                            container
                            spacing={3}
                            sx={{ mt: { xs: 0, md: 6 } }}
                            justifyContent="center"
                            alignItems="center"
                            textAlign="center"
                        >
                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="business"
                                    title="Sediu curat permanent"
                                    description="Asiguram un mediu curat, bine întreținut și primitor în sediul dumneavoastră, pentru confortul angajaților și al vizitatorilor."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="inventory_2"
                                    title="Fără grija logisticii"
                                    description="Gestionăm integral personalul, echipamentele, materialele și aprovizionarea, pentru ca dumneavoastră să vă bucurați de confort fără bătăi de cap"
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="badge"
                                    title="Echipă cu experiență & acte în regulă"
                                    description="Personal calificat, echipat profesional, angajat legal și verificat complet din punct de vedere al cazierului."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="workspace_premium"
                                    title="Servicii garantate & asigurate"
                                    description="Oferim calitate superioară, suport continuu și asigurare profesională, pentru siguranța și liniștea dumneavoastră."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="desk"
                                    title="Respect pentru spațiul de lucru"
                                    description="Menținem ordinea pe birouri și echipamente, intervenind cu discreție pentru a nu perturba activitatea."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="discount"
                                    title="Reduceri lunare"
                                    description="Beneficiezi de 10% reducere pentru toate serviciile contractate prin abonamente lunare."
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
